import { AlertsSiren, Frame, Tasks } from "@dreamhub/designsystem/icons";
import FocusCard from "@/components/controls/Focus/FocusCard";
import GradientBlur from "@/components/controls/GradientBlur";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import Text from "@/components/ui/text";
import React from "react";
import { useTranslation } from "react-i18next";

const TRANSLATION_KEY = "focus.empty";

const FocusComingSoon: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Card className="relative flex overflow-hidden">
      <div className="flex flex-col">
        <CardHeader className="flex flex-row w-full justify-between space-x-4 px-6 py-5">
          <div className="flex flex-col gap-2">
            <Text variant="lgSubtitle">{t(`${TRANSLATION_KEY}.title`)}</Text>
            <Text variant="bodySecondary">
              {t(`${TRANSLATION_KEY}.subtitle`)}
            </Text>
          </div>
          <div className="h-fit px-3 py-2 rounded-full bg-badges-selected">
            <Text variant="labelSecondary">
              {t(`${TRANSLATION_KEY}.comingSoon`)}
            </Text>
          </div>
        </CardHeader>
        <CardContent className="pt-6 px-8 pb-10 grid grid-cols-3 gap-8 w-full">
          <FocusCard
            icon={<Tasks />}
            title={t(`${TRANSLATION_KEY}.prioritize.title`)}
            subtitle={t(`${TRANSLATION_KEY}.prioritize.subtitle`)}
          />
          <FocusCard
            icon={<AlertsSiren />}
            title={t(`${TRANSLATION_KEY}.stayInformed.title`)}
            subtitle={t(`${TRANSLATION_KEY}.stayInformed.subtitle`)}
          />
          <FocusCard
            icon={<Frame />}
            title={t(`${TRANSLATION_KEY}.bePrepared.title`)}
            subtitle={t(`${TRANSLATION_KEY}.bePrepared.subtitle`)}
          />
        </CardContent>
      </div>
      <GradientBlur className="md:left-[25rem] lg:left-[30rem] xl:left-[35rem]" />
      <GradientBlur className="md:left-[35rem] lg:left-[40rem] xl:left-[45rem]" />
      <GradientBlur className="md:left-[45rem] lg:left-[50rem] xl:left-[55rem]" />
    </Card>
  );
};

export default FocusComingSoon;
